export enum LoadingStatus {
    Initial = "Initial",
    Loading = "Loading",
    Successful = "Successful",
    SuccessfulEmpty = "SuccessfulEmpty",
    Errored = "Errored",
}
